import { apiClient } from '../api/api';

const STORE_LIST_CACHE_KEY = 'storeList';

export async function getStores() {
    const storedList = localStorage.getItem(STORE_LIST_CACHE_KEY);

    if (storedList) {
        try {
            return JSON.parse(storedList);
        } catch {
            localStorage.removeItem(STORE_LIST_CACHE_KEY);
        }
    }

    try {
        const result = await apiClient.post<{
            message?: string;
            data: any[];
        }>('/store/storeList');

        const storeList = result.data || [];

        localStorage.setItem(STORE_LIST_CACHE_KEY, JSON.stringify(storeList));

        return storeList;
    } catch (error) {
        console.log('Unable to get store data:', error);
        return [];
    }
}

export function clearStoresCache() {
    localStorage.removeItem(STORE_LIST_CACHE_KEY);
}


/**
 * Create a new store.
 */
export const createStore = async (payload: any) => {
    const result = await apiClient.post<{
        message: string;
        data: any;
    }>('/store/create', payload);

    clearStoresCache();

    return result;
};

/**
 * Update existing store.
 */
export const updateStore = async (payload: any) => {
    const result = await apiClient.post<{
        message: string;
        data?: any;
    }>('/store/update', payload);

    clearStoresCache();

    return result;
};